/* eslint-disable react/require-default-props */
/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-props-no-spreading */
import React, {
    useEffect, useContext, Suspense,
} from 'react';
import { Portal } from 'react-portal';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import compose from 'lodash/flowRight';
import {
    useMutation, useQuery, useSuspenseQuery,
} from '@apollo/client';
import { useBillingMutation } from 'app/hooks/useBillingMutation';
import { promocodeVar, selectedPeriodVar } from 'app/apollo/reaction';

import { VIEW_CUSTOMIZATION_COMMENT } from 'app/graphql/network/customizationComment';
import { GET_CHECKOUT_DATA } from 'app/graphql/client/checkout';

import {
    cartType,
} from 'types/basketQuery.type';

import { analyticService } from 'global/services';
import connect from 'app/connect';

import { useRouterState } from 'app/hooks/useRouterState';
import { useBasketQueryAdapter } from 'app/connect/connectToBasket';
import { FiltersContext } from 'app/containers/contexts/filters.context/filters.context';

import { PERIOD_IS_DISABLED_ERROR_MESSAGE } from 'app/const/basket-errors';
import { CREATE_EVENT } from 'app/graphql/network/createEvent';
import { STORE_ENV_DATA } from 'app/graphql/network/envDataMutation';
import { idGenerator } from 'app/utils/classes/uniqueIdGenerator';
import { isDesktop } from 'app/utils/resolution';
import { LocaleContext } from 'app/containers/LocaleProvider';
import {
    CATEGORY, MenuDispatchContext,
} from 'app/containers/contexts/menu.context';
import { menuDatesState } from 'app/containers/contexts/menuDates.context';
import { LocationContext } from 'app/containers/LocationProvider';

import Responsive from 'app/components/Responsive';

import ErrorContent from 'app/components/ErrorContent';
import formatPrice from 'app/utils/price';
import { useToggleSubscription } from 'app/hooks/useToggleSubscription';


import { Toast } from 'app/components/ui/Toast';
import { DialogAnimated } from 'app/components/Dialog';
import { UIButton, UIButtonBottomArea } from 'app/components/ui';
import FloatFooterDiscountCounter from 'app/components/FloatFooterDiscountCounter';
import { BasketSkeletonPage } from 'app/components/Skeletons/BasketPageSkeletons';
import { useCashbackNewUsersABTest } from 'app/hooks';
import {
    abTestDataContext,
    UPSELL_AFTER_BASKET,
    UPSELL_AFTER_BASKET_TEST,
} from 'app/containers/contexts/abTest.context';

import {
    TagsContentForABDialog,
} from './enums/basket';

import LoadingBasket from './components/LoadingBasket';
import { BasketCheckArea } from './BasketCheckArea';

import BasketHeaderArea from './BasketHeaderArea';
import BasketListArea from './BasketListArea';
import BasketPromoArea from './BasketPromoArea';
import { locales } from './basket.locales';
import { useBasketUISelector } from './basketStore/basketUiStore.context';

import './basket.scss';
import { pickCategoryReaction } from '../../apollo/reactions/filters';

/* FETCH */
import { BASKET_PAGE_ROOT_QUERY } from './graphql/initialBasketPageQuery.graphql';
import { useCartMutationInBasket } from './hooks';
import {
    getDishAddedPeriod,
    removeAddedDish,
} from './components/BasketNewUpsell/components/BasketTopDishCard/addedPeriodStorage';
import EmptyBasket from './components/EmptyBasket';
import { BasketFooterButton } from './components/BasketFooterButton';
import { BasketFrame } from './CommonComponents/BasketFrame';

// TODO: Возможно нужно убрать это ---------------------------------------------
import { getConfirmCustomizationLocales } from './components/BasketCustomizationTags.DEPRECATED/basket-customization-locales';
import { useCustomContradictionCheck } from './hooks/useCustomContradictionCheck';
import { searchForCustomizationContradiction, findMostImportantContradictionTag } from './utils/customizationContradictionUtils';
import { mealprepDishes } from '../../../../landings/promo-checkout/src/pages/_disabled/mealprep/dishesData';


// TODO: Выяснить что это за константа
const CLOSED = 'closed';

const backgroundColor = '#F8F8F8';

/* timeout for customization comment sidebar closing animation */
const OVERLAY_DISSAPEARING_DELAY = 700;

const possibleLoadingStatus = [
    'loading_basket',
    // 'loading_trial_basket',
    // 'loading_promo_selection_basket', // BR-948
    'loading_picture_size_test_basket', // BR-958
    'loading_picture_size_trial_test_basket', // BR-958
    'initial_basket',
];
const isDishesSectionsCountChanged = (cart, prevCart) => {
    const { sections } = cart;
    const { sections: prevSections } = prevCart;
    return sections.length !== prevSections.length;
};

export const getDishIdsFromSection = (section) => section.items.map((i) => i.dish_id);

export const getDishIds = (sections) => sections.reduce((acc, i) => [...getDishIdsFromSection(i), ...acc], []);

const isDishesCountChanged = (cart, prevCart) => {
    const { sections } = cart;
    const { sections: prevSections } = prevCart;

    return getDishIds(sections).length !== getDishIds(prevSections).length;
};

const isAllCategoriesInvisibled = (categories, invisibleCategories) => {
    const isBasketEmpty = categories.length === 0;
    const isLastCategoriesInvisibled = invisibleCategories.length !== 0 && categories.length === 1;

    return isBasketEmpty || isLastCategoriesInvisibled;
};

class Basket extends React.Component {
    state = {
        isCustomizationCommentAreaShown: false,
        isCustomizationCommentSidebarShown: false,
        isCustomizationDialogShown: false,
        customizationCommentShowingState: CLOSED, // opened, closed
        bodyInitialBackground: null,
        // isEnterTransitionEnded: false,
        invisibleCategories: [],
        invisibleDishes: [],
        dialogIngridient: null,
        isCustomizationEdited: false,
    };

    showPaperRecipeRow = true;

    // Life cycle ==============================================================

    componentDidMount() {
        const {
            history,
        } = this.props;

        const { location: { search } } = window;

        this.setBodyInitialBackground({ callback: this.setBodyBackground });
    }

    componentDidUpdate(prevProps) {
        const {
            basketQuery: { cart, error },
        } = this.props;

        const {
            basketQuery: { cart: prevCart },
        } = prevProps;

        const isOnlyMealPrepDishesInBasket = this.checkMealPrepDishesInBasket();
        sessionStorage.setItem('isOnlyMealPrepDishesInBasket', isOnlyMealPrepDishesInBasket);

        if (error) {
            return;
        }

        this.scrollToTopOnEntered(prevProps);

        const isCartsExist = cart && prevCart;

        if (isCartsExist && isDishesSectionsCountChanged(cart, prevCart)) {
            this.resetInvisibleCategories();
        }

        if (isCartsExist && isDishesCountChanged(cart, prevCart)) {
            this.updateInvisibleDishes();
        }
    }

    componentWillUnmount() {
        sessionStorage.removeItem('gotBasketFromPreview');
        this.resetBodyBackground();
    }

    // Handlers and Actions ====================================================

    setBodyInitialBackground({ callback }) {
        const { body } = document;
        this.setState({ bodyInitialBackground: body.style.backgroundColor }, callback);
    }

    setBodyBackground = () => {
        const { body } = document;
        body.style.backgroundColor = backgroundColor;
    };

    // eslint-disable-next-line react/sort-comp
    resetBodyBackground() {
        const { bodyInitialBackground } = this.state;
        const { body } = document;

        body.style.backgroundColor = bodyInitialBackground;
    }

    addInvisibleCategory(categoryId, callback) {
        const { invisibleCategories } = this.state;

        this.setState(
            { invisibleCategories: [categoryId, ...invisibleCategories] },
            callback,
        );
    }

    resetInvisibleCategories() {
        this.setState({ invisibleCategories: [] });
    }

    addInvisibleDish(dishId, callback) {
        const { invisibleDishes } = this.state;

        this.setState(
            { invisibleDishes: [dishId, ...invisibleDishes] },
            callback,
        );
    }

    updateInvisibleDishes() {
        const { basketQuery: { cart: { sections } } } = this.props;
        const { invisibleDishes } = this.state;

        const dishes = getDishIds(sections);
        const filteredInvisibleDishes = invisibleDishes.filter((i) => dishes.includes(i));

        this.setState({ invisibleDishes: filteredInvisibleDishes });
    }

    applyPromocodeHandler = async (nextPromocode) => {
        const {
            basketQuery,
            mutateBilling,
        } = this.props;

        promocodeVar(nextPromocode);
        const data = await mutateBilling({
            variables: {
                promocode: nextPromocode,
            },
        });

        const cart = data?.billing?.cart || {};

        const {
            promocode,
            promocode_status: promocodeStatus,
            isPromocodeCombineWithDiscount,
            isPromoCodeExists,
            isSubscriptionActivated,
        } = cart.discount_conditions;


        analyticService.push({
            isPromoCodeExists,
            isPromocodeCombineWithDiscount,
            isSubscriptionActivated,
            promo: promocode,
            promocodeStatus,
            eventName: 'Check_Send_Promo',
            sourceName: 'basket_check',
        });

        return {
            cart,
            promocodeConditions: cart.discount_conditions,
        };
    };

    handleToCheckout = async () => {
        const {
            openUpsell,
            openCheckout,
            abTestDataContext,
        } = this.props;

        analyticService.push({ eventName: 'Go_to_Checkout' });
        openCheckout();

        // const upsellDishAdded = sessionStorage.getItem('upsellDishAdded');

        // if (sessionStorage.getItem(`upsellShown:${selectedPeriodVar()}`) && !upsellDishAdded) {
        //     openCheckout();
        //     analyticService.push({ eventName: 'Go_to_Checkout' });
        //     return;
        // }

        // const isUpsellAfterBasketTest = await abTestDataContext.fetchABTestValue(UPSELL_AFTER_BASKET);

        // if (isUpsellAfterBasketTest === UPSELL_AFTER_BASKET_TEST && !isDesktop()) {
        //     sessionStorage.setItem('upsellShown', '1');
        //     openUpsell();
        // } else {
        //     openCheckout();
        // }
        // analyticService.push({ eventName: 'Go_to_Checkout' });
    };

    handleOpenMobileDishDetails = (itemData) => {
        const {
            filterQuery: { menuFilter: { periods } },
            selectedFilters: { selectedPeriod },
            onClickMobileDishDetails,
            subscriptionType,
        } = this.props;

        onClickMobileDishDetails(itemData);

        const { item: { dish } } = itemData;
        const period = periods.find((p) => p.start === selectedPeriod);
        const category = period.categories.find((c) => c.id === String(dish.categoryId));

        analyticService.push({
            ...dish,
            category,
            source: 'basket',
            eventName: 'Dish_Details_Viewed',
            subscriptionType,
        }).push({
            id: dish.id,
            eventName: 'CityAds_Dish_Details_Viewed',
        });
    };

    // FIXIT: basketQuery.refetch is not a function
    handleChangePortion = async ({ value, id }) => {
        const { mutateItemInCart } = this.props;
        mutateItemInCart(
            { dishes: [{ dish_id: id, portions: value }], optimistic: 'portion' },
        );
    };

    handleRemoveDish = (dishId) => {
        const { mutateItemInCart } = this.props;
        /* список доп. блюд читает запись из sessionStorage: если удаляем блюдо
         * из корзины того же цикла, в который его клали с баннера, запись
         * устареет и чекаут создаст пустой доп. инвойс. Для другого цикла
         * (блюдо есть и в текущей корзине) запись не трогаем */
        const addedPeriod = getDishAddedPeriod(dishId);
        if (addedPeriod && addedPeriod === selectedPeriodVar()) {
            removeAddedDish(dishId);
        }
        mutateItemInCart(
            { dishes: [{ dish_id: dishId, portions: 0 }] },
        );
    };

    handleAddMoreButtonClick = async (categoryId) => {
        const {
            closeBasket,
            menuDispatchContext,
        } = this.props;

        pickCategoryReaction({ categoryId });
        menuDispatchContext({
            type: 'scrollTo',
            payload: { target: CATEGORY, value: categoryId },
        });
        analyticService.push({
            eventName: 'Change_Filter_Item',
            itemKey: 'category',
            action: 'on',
            categoryId,
        });

        closeBasket();
    };

    scrollToTopOnEntered(prevProps) {
        if (isDesktop()) return;
        const { transitionState } = this.props;
        const { transitionState: prevTransitionState } = prevProps;
        const isEntered = transitionState === 'entered' && prevTransitionState !== 'entered';
        if (isEntered) {
            window.scrollTo(0, 0);
        }
    }

    toggleCustomizationCommentSidebar() {
        const { isCustomizationCommentAreaShown: isCommentShown } = this.state;

        if (isCommentShown) this.setState({ isCustomizationCommentSidebarShown: isCommentShown });

        if (!isCommentShown) {
            setTimeout(() => this.setState({ isCustomizationCommentSidebarShown: isCommentShown }), OVERLAY_DISSAPEARING_DELAY);
        }
    }

    toggleCustomizationCommentArea = (isShown) => () => {
        const { isCustomizationCommentAreaShown } = this.state;

        this.setState(
            { isCustomizationCommentAreaShown: isShown || !isCustomizationCommentAreaShown },
            () => this.toggleCustomizationCommentSidebar(),
        );
    };

    setCustomizationCommentShowingState = (state) => () => this.setState({ customizationCommentShowingState: state });

    handleOpenCloseCustomizationDialog = (value) => {
        this.setState({ isCustomizationDialogShown: value });
    };


    // Render ==================================================================
    /**
     * @description Fill screen by color when there is transition to empty basket
     */
    renderFiller() {
        const { invisibleCategories } = this.state;
        const sections = this.props?.basketQuery?.cart?.sections || [];
        const basketStyleModifier = this.props?.prearedBasketAreas?.basketStyleModifier;
        const fillerClasses = classNames({
            'basket-filler': true,
            active: isAllCategoriesInvisibled(sections, invisibleCategories) && basketStyleModifier !== 'empty_basket',
        });

        return <div styleName={fillerClasses} />;
    }

    renderFooterButton(props = {}) {
        const {
            basketQuery: { cart: { sections, totals, discount_conditions: discountConditions } },
            closeBasket,
            localeContext: { locale },
        } = this.props;

        const { emptyButtonText, fullButtonText } = locales[locale];

        const { isOnlyGiftInBasket } = props;

        const isBasketEmpty = sections.length === 0 || isOnlyGiftInBasket;

        const originalPrice = isBasketEmpty ? null : totals.total_price + totals.delivery_price;
        const price = isBasketEmpty ? null : totals.total_common_price;
        const title = isBasketEmpty ? emptyButtonText : fullButtonText;

        const footerClasses = classNames({
            'basket-footer': true,
        });

        return (
            <div styleName={footerClasses}>
                <UIButtonBottomArea zIndex="10" position="static">
                    <FloatFooterDiscountCounter
                        promocodeConditions={discountConditions}
                    />
                    <UIButton
                        onClick={() => this.defineCurrentFooterButtonHandler(isBasketEmpty)}
                        aria-label="Оформить заказ"
                    >
                        <span className="title">{title}</span>
                        {price && (
                            <span className="price">
                                <span className="num">{formatPrice(price)}</span>
                                <span className="rub">₽</span>
                            </span>
                        )}
                        {originalPrice && originalPrice !== price && (
                            <span className="original-price">
                                <span className="num">{formatPrice(originalPrice)}</span>
                                {/* <span className="num">3 000</span> */}
                                <span className="rub">₽</span>
                            </span>
                        )}
                    </UIButton>
                </UIButtonBottomArea>
            </div>
        );
    }

    handleSetIsCustomizationEdited = (value) => {
        this.setState({ isCustomizationEdited: value });
        if (value) {
            sessionStorage.setItem('is_customization_edited', 'true');
        }
    };

    defineCurrentFooterButtonHandler = (isBasketEmpty = false) => {
        const {
            closeBasket,
            basketQuery,
            userQuery,
        } = this.props;
        if (isBasketEmpty) {
            closeBasket();
            return;
        }
        const {
            checkIsСontraditionSearchNeeded,
        } = this.props;
        const isContradictionSearchNeeded = checkIsСontraditionSearchNeeded();

        if (!isContradictionSearchNeeded) {
            this.handleToCheckout();
            sessionStorage.removeItem('with_customization');
            return;
        }

        const { isCustomizationEdited } = this.state;

        const missingTags = searchForCustomizationContradiction(
            basketQuery?.cart,
            userQuery?.user?.customizationTags,
        );
        const hasCustomizationContradiction = Boolean(missingTags.length);

        const mostImportantContradictionTag = findMostImportantContradictionTag(missingTags);
        const tagFromEnumExists = mostImportantContradictionTag !== null;

        if (hasCustomizationContradiction && (mostImportantContradictionTag in TagsContentForABDialog)) {
            this.setState({ dialogIngridient: TagsContentForABDialog[mostImportantContradictionTag] });
        }

        const isShowContradictionDialogNeeded = Boolean(mostImportantContradictionTag)
            && tagFromEnumExists
            && !isCustomizationEdited;

        if (isCustomizationEdited) {
            sessionStorage.setItem('with_customization', 'false');
            sessionStorage.setItem('is_customization_edited', 'true');
            this.handleToCheckout();
            return;
        }

        if (isShowContradictionDialogNeeded) {
            this.handleOpenCloseCustomizationDialog(true);
            return;
        }
        sessionStorage.removeItem('with_customization');
        this.handleToCheckout();
    };

    checkMealPrepDishesInBasket = () => {
        const { basketQuery: { cart: { sections } } } = this.props;

        const dishes = getDishIds(sections);
        return dishes.some((d) => mealprepDishes.includes(d));
    };

    render() {
        const {
            localeContext: { locale },
            prearedBasketAreas,
            prearedBasketAreas: {
                list: { isEmptyBasket },
            },

            // DATA
            checkoutData: { subdivision },
            basketQuery: {
                error,
                cart,
            },
            subscriptionTypeQuery: { subscriptionType },
            // STATE PROPS
            hiddenElements,
            // ACTION
            closeBasket,
            onClickMobilePortions,
            openDeliveryPricePopup,
            // MUTATION
            mutateItemInCart,
            isCartUpdating,
            isCartEmpty,
            toggleSubscription,
        } = this.props;

        const hasMealprepDishesInCart = this.checkMealPrepDishesInBasket();

        const {
            invisibleCategories,
            invisibleDishes,
            isCustomizationDialogShown,
            customizationCommentShowingState,
            dialogIngridient,
            isCustomizationEdited,
        } = this.state;

        const isBasketEmpty = cart?.sections.length === 0;

        // TODO: Подумать что сделать с ошибкой
        /* ERROR BASKET */
        if (error) {
            const isBasketErrorHandled = error.message && error.message.includes(PERIOD_IS_DISABLED_ERROR_MESSAGE);
            if (!isBasketErrorHandled) {
                return (
                    <div styleName="basket">
                        <LoadingBasket>
                            <ErrorContent />
                        </LoadingBasket>
                    </div>
                );
            }
        }

        const {
            sections,
        } = cart ?? { sections: [] };

        // FOOTER
        const giftSection = sections.find((s) => s.gift_category);
        const isOnlyGiftInBasket = giftSection && sections.length === 1;

        const isEditEnabled = !hiddenElements.edit_basket;

        const showAddMoreButton = !hiddenElements.backstep;

        const dialogTexts = dialogIngridient
            ? getConfirmCustomizationLocales(dialogIngridient[locale])[locale].dialog.success
            : null;

        /* CLASSES */
        const headerRootclasses = classNames({
            'basket-header': true,
            'basket-header--static': !(isEmptyBasket || customizationCommentShowingState === 'opened'),
        });

        return (
            <>
                {/* HEADER */}
                <div styleName={headerRootclasses}>
                    <BasketHeaderArea
                        hiddenElements={hiddenElements}
                        prearedBasketAreas={prearedBasketAreas}
                        customizationCommentShowingState={customizationCommentShowingState}
                        toggleCustomizationCommentArea={this.toggleCustomizationCommentArea}
                        closeBasket={closeBasket}
                    />
                </div>
                <Toast
                    text="Добавлено в корзину"
                    delay={1600}
                    customEventName="executeBasketToastNotification"
                />
                {/* TOP */}
                {isCartEmpty && <EmptyBasket locale={locale} />}
                {!isCartEmpty && (
                    <div styleName="basket-categories__scroll-content" id="basketAreasListDesktop">
                        {/* LIST */}
                        <BasketListArea
                            {...this.props}
                            handleChangePortion={this.handleChangePortion}
                            handleRemoveDish={this.handleRemoveDish}
                            handleOpenMobileDishDetails={this.handleOpenMobileDishDetails}
                            handleAddMoreButtonClick={this.handleAddMoreButtonClick}
                            onClickMobilePortions={onClickMobilePortions}
                            mutateItemInCart={mutateItemInCart}
                            // SATE PROPS
                            invisibleCategories={invisibleCategories}
                            invisibleDishes={invisibleDishes}
                            showAddMoreButton={showAddMoreButton}
                            isEditEnabled={isEditEnabled}
                            subscriptionType={subscriptionType}
                            preparedBasketAreas={prearedBasketAreas}
                            isCartUpdating={isCartUpdating}
                            showPaperRecipeRow={this.showPaperRecipeRow}
                        />
                        {/* PROMO */}
                        <BasketPromoArea
                            preparedBasketAreas={prearedBasketAreas}
                            closeHandler={closeBasket}
                            handleSetIsCustomizationEdited={this.handleSetIsCustomizationEdited}
                        />
                        <BasketCheckArea
                            renderContext="basket"
                            prearedBasketAreas={prearedBasketAreas}
                            subdivision={subdivision}
                            locale={locale}
                            hiddenElements={hiddenElements}
                            onClickDeliveryPrice={openDeliveryPricePopup}
                            onToggleSubscription={toggleSubscription}
                            applyPromocodeHandler={this.applyPromocodeHandler}
                            subscriptionType={subscriptionType}
                            basketDishUiStateDispatch={() => { }}
                            isCartUpdating={isCartUpdating}
                            hasMealprepDishesInCart={hasMealprepDishesInCart}
                        />
                        {!isCustomizationEdited && (
                            <Portal>
                                <DialogAnimated
                                    {...dialogTexts}
                                    isOpen={Boolean(isCustomizationDialogShown)}
                                    onConfirm={() => {
                                        sessionStorage.setItem('with_customization', 'false');
                                        this.handleToCheckout();
                                        this.handleOpenCloseCustomizationDialog(false);
                                    }}
                                    onReject={() => {
                                        sessionStorage.removeItem('with_customization');
                                        this.handleOpenCloseCustomizationDialog(false);
                                    }}
                                />
                            </Portal>
                        )}
                    </div>
                )}
                <Responsive mobile={this.renderFiller()} />
                <div styleName="basket-footer">
                    <BasketFooterButton
                        handleToCheckout={() => this.defineCurrentFooterButtonHandler(isBasketEmpty)}
                        closeBasket={closeBasket}
                        isOnlyGiftInBasket={isOnlyGiftInBasket}
                        isCartUpdating={isCartUpdating}
                    />
                </div>
            </>
        );
    }
}

// filterDishesForNYPeriods() {
//     const {
//         basketQuery: {
//             cart: {
//                 sections,
//                 typeOfSet,
//             },
//         },
//         mutateItemInCart,
//     } = this.props;

//     const typeOfSetFromUrl = queryString.parse(window.location.search)?.menu;

//     if (typeOfSet === 'everyday' || typeOfSetFromUrl) {
//         return;
//     }

//     const period = selectedPeriodVar();

//     const {
//         dishesWithoutTargetTag: dishesWithoutNYTag,
//         dishesWithTargetTag: dishesWithNYTag,
//     } = this.checkDishesInBasketByTag(NY_DISHES);
//     const {
//         dishesWithTargetTag: dishesWithNYDessertsTag,
//     } = this.checkDishesInBasketByTag(NY_DESSERT);

//     const isNYPeriod = period === NYPeriodStart || period === NYPeriodStartRegions;
//     const isNearNYPeriod = period === extraPeriodNYStart;

//     let dishesCollectionToDelete = [];
//     // if (isNYPeriod) {
//     //     dishesCollectionToDelete = dishesWithoutNYTag;
//     // }
//     // if (isNearNYPeriod) {
//     //     dishesCollectionToDelete = dishesWithNYTag;
//     // }

//     // остались только ЕЕ на 4-ое...
//     if (isNYPeriod) {
//         dishesCollectionToDelete = dishesWithNYTag;
//     }

//     if (dishesCollectionToDelete.length) {
//         const allDishesToDelete = sections
//             .map((s) => s.items)
//             .flat()
//             .filter((dish) => {
//                 const hasDessertTag = dishesWithNYDessertsTag.includes(dish.dish_id);
//                 if (hasDessertTag) {
//                     return null;
//                 }
//                 return dishesCollectionToDelete.includes(dish.dish_id);
//             });
//         mutateItemInCart(
//             { dishes: allDishesToDelete.map((dish) => ({ dish_id: dish.dish_id, portions: 0 })), optimistic: 'portion' },
//         );
//     }
// }

Basket.propTypes = {
    /* Query and Mutation */
    basketQuery: PropTypes.shape({
        loading: PropTypes.bool,
        error: PropTypes.shape({
            message: PropTypes.string,
        }),
        cart: PropTypes.shape(cartType),
        refetch: PropTypes.func.isRequired,
    }),

    /* ---- */
    basketDishUiStateDispatch: PropTypes.func,
    uiBasketState: PropTypes.shape({
        isWellcomeDiscountButton: PropTypes.bool,
        isAuthDetailOpen: PropTypes.bool,
    }),
    localeContext: PropTypes.shape({
        locale: PropTypes.string,
    }).isRequired,

    locationContext: PropTypes.shape({
        locationKey: PropTypes.string.isRequired,
    }).isRequired,

    openUpsell: PropTypes.func.isRequired,
    closeBasket: PropTypes.func.isRequired,
    abTestDataContext: PropTypes.shape({}).isRequired,

    transitionState: PropTypes.string.isRequired,

    promocode: PropTypes.shape({}).isRequired,

    userQuery: PropTypes.shape({
        user: PropTypes.shape({
            phone: PropTypes.string,
        }),
    }).isRequired,

    filterQuery: PropTypes.shape({
        menuFilter: PropTypes.shape({
            periods: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        }).isRequired,
    }).isRequired,
    menuDishesQuery: PropTypes.shape({
        allDishes: PropTypes.arrayOf(PropTypes.shape({})),
        basketDishes: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
    selectedFilters: PropTypes.shape({
        selectedPeriod: PropTypes.string,
    }).isRequired,

    subscriptionTypeQuery: PropTypes.shape({
        subscriptionType: PropTypes.string.isRequired,
    }).isRequired,

    updateBilling: PropTypes.func.isRequired,

    paymentMethod: PropTypes.shape({
        paymentMethod: PropTypes.string,
    }).isRequired,

    onClickMobilePortions: PropTypes.func.isRequired,
    onClickMobileDishDetails: PropTypes.func,

    hiddenElements: PropTypes.shape({
        backstep: PropTypes.bool,
        payment_button_recurrent: PropTypes.bool,
        payment_button_online: PropTypes.bool,
        payment_button_offline: PropTypes.bool,
        edit_basket: PropTypes.bool,
    }).isRequired,

    checkoutData: PropTypes.shape({
        subdivision: PropTypes.string,
    }).isRequired,

    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        replace: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
        search: PropTypes.string,
    }).isRequired,
    menuDispatchContext: PropTypes.func.isRequired,
    onDishRemoved: PropTypes.func.isRequired,

    openDeliveryPricePopup: PropTypes.func.isRequired,

    isShifted: PropTypes.bool,
    viewCustomizationComment: PropTypes.shape({
        comment: PropTypes.string,
    }),
    prearedBasketAreas: PropTypes.shape({
        basketStyleModifier: PropTypes.string.isRequired,
    }).isRequired,
};

const BasketAdapder = (props) => {
    const [routerState] = useRouterState();
    const { history, location } = routerState;
    /* CONTEXTS ------------------------------------------------------------- */
    const menuDispatchContext = useContext(MenuDispatchContext);
    const localeContext = useContext(LocaleContext);
    const locationContext = useContext(LocationContext);
    const menuDatesContext = useContext(menuDatesState);
    const abTestData = useContext(abTestDataContext);

    const [toggleSubscription] = useToggleSubscription();

    const { basketQuery } = useBasketQueryAdapter();
    const { filterQuery } = useContext(FiltersContext);

    /* HOOKS ---------------------------------------------------------------- */
    const { prearedBasketAreas, ...restProps } = useBasketUISelector({
        ...props,
        basketQuery,
        menuDispatchContext,
        localeContext,
        locationContext,
        abTestDataContext: abTestData,
        menuDatesContext,
    });

    const contradictionData = useCustomContradictionCheck();

    /* DA ------------------------------------------------------------------- */
    const { mutateBilling } = useBillingMutation();

    const { data } = useSuspenseQuery(BASKET_PAGE_ROOT_QUERY, {
        fetchPolicy: 'cache-first',
    });
    const { data: { checkoutData } } = useQuery(GET_CHECKOUT_DATA, {
        context: {
            message: 'basket:root:BasketAdapder @client',
        },
    });
    useCashbackNewUsersABTest();

    const [createEventMutation] = useMutation(CREATE_EVENT);
    const [storeEnvData] = useMutation(STORE_ENV_DATA);
    const { isCartUpdating, mutateItemInCart } = useCartMutationInBasket();

    const {
        data: { viewCustomizationComment },
    } = useQuery(VIEW_CUSTOMIZATION_COMMENT);

    const {
        selectedFilters: { selectedPeriod },
    } = props;
    const { cart, error: basketQueryError } = basketQuery;

    /* EFFECTS -------------------------------------------------------------- */
    useEffect(() => {
        if (cart?.sections.length) {
            analyticService.push({
                eventName: 'Track_Navigate',
                step: 1,
                sections: cart.sections,
                totals: cart.totals,
                period: selectedPeriod,
                typeOfSet: cart.typeOfSet,
            }).push({
                eventName: 'CityAds_Basket_Navigate',
                sections: cart.sections,
            });

            if (window.location.search.search('adid=') > 0) {
                createEventMutation({
                    variables: {
                        period: selectedPeriod,
                        eventType: 'cart_open',
                    },
                });
            }
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (
            abTestData[UPSELL_AFTER_BASKET] !== 'unfetched'
            && !sessionStorage.getItem('participantId')
            && selectedPeriod
        ) {
            const participantId = idGenerator.generateId();
            storeEnvData({
                variables: {
                    participantId,
                    period: selectedPeriod,
                },
            })
                .then(
                    () => sessionStorage.setItem('participantId', participantId),
                );
        }
    }, [abTestData, selectedPeriod, storeEnvData]);

    const { basketStyleModifier } = prearedBasketAreas;

    /* RENDER --------------------------------------------------------------- */
    if (possibleLoadingStatus.includes(basketStyleModifier)) {
        return <BasketSkeletonPage />;
    }

    if (basketQueryError) {
        return (
            (
                <Basket
                    {...props}
                    {...restProps}
                    {...contradictionData}
                    toggleSubscription={toggleSubscription}
                    history={history}
                    location={location}
                    filterQuery={filterQuery}
                    basketQuery={basketQuery}
                    checkoutData={checkoutData}
                    menuDispatchContext={menuDispatchContext}
                    viewCustomizationComment={viewCustomizationComment}
                    mutateItemInCart={mutateItemInCart}
                    isCartUpdating={isCartUpdating}
                    isCartEmpty={data?.cart?.isSectionsEmpty}
                    prearedBasketAreas={prearedBasketAreas}
                    mutateBilling={mutateBilling}
                    abTestDataContext={abTestData}
                />
            )
        );
    }

    /**
      * @note управляющая логика анимацией добавления в корзину блюд
      * @TODO: подумать как объединить добавление и удалению блюд в одном компоненте
      */
    return (
        <Basket
            {...props}
            {...restProps}
            {...contradictionData}
            history={history}
            location={location}
            basketQuery={basketQuery}
            filterQuery={filterQuery}
            checkoutData={checkoutData}
            toggleSubscription={toggleSubscription}
            mutateItemInCart={mutateItemInCart}
            isCartUpdating={isCartUpdating}
            isCartEmpty={data?.cart?.isSectionsEmpty}
            menuDispatchContext={menuDispatchContext}
            viewCustomizationComment={viewCustomizationComment}
            prearedBasketAreas={prearedBasketAreas}
            mutateBilling={mutateBilling}
            abTestDataContext={abTestData}
        />
    );
};

function BasketRootContainer(props) {
    return (
        <BasketFrame>
            <Suspense fallback={<BasketSkeletonPage />}>
                <BasketAdapder {...props} />
            </Suspense>
        </BasketFrame>
    );
}

BasketAdapder.propTypes = {
    basketQuery: PropTypes.shape({
        cart: PropTypes.shape(cartType),
        error: PropTypes.shape({}),
    }),
    selectedFilters: PropTypes.shape({
        selectedPeriod: PropTypes.string.isRequired,
    }).isRequired,
};

export default compose(
    connect,
    React.memo,
)(BasketRootContainer);
